import { render, staticRenderFns } from "./ProfileShare.vue?vue&type=template&id=1ec929b9&"
import script from "./ProfileShare.vue?vue&type=script&lang=js&"
export * from "./ProfileShare.vue?vue&type=script&lang=js&"
import style0 from "./ProfileShare.vue?vue&type=style&index=0&id=1ec929b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports